var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box risk"},[_c(_vm.curr,{ref:"riskEditView",tag:"component"}),_vm._v(" "),_c(_vm.findThing,{tag:"component",attrs:{"visible":_vm.showDialog,"ajax":_vm.listAjax},on:{"close":_vm.closeDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }